import { useEffect } from "react"
import { usePage } from "@inertiajs/react"

const STATUS_TAB = {
    sold: "sold",
    live: "active",
}

/**
 * Resolve a listing's initial tab. The page always opens on `fallback` ("all"
 * by default) unless the URL carries the optional `auction_status` param, which
 * wins: `sold` selects the Sold tab and `live` selects the Active tab. The param
 * is read from Inertia's page url (consistent across SSR and the client, so no
 * hydration mismatch) and then stripped from the address bar client-side — tab
 * switching never touches the URL, so the param has done its one job.
 */
export default function useListingDefaultTab(fallback = "all") {
    const { url } = usePage()
    const status = new URLSearchParams(url.split("?")[1] ?? "").get(
        "auction_status"
    )

    useEffect(() => {
        if (!status || typeof window === "undefined") {
            return
        }
        const next = new URL(window.location.href)
        next.searchParams.delete("auction_status")
        window.history.replaceState(window.history.state, "", next.toString())
        // Mount-only: the param seeds the initial tab and is then discarded.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return STATUS_TAB[status] ?? fallback
}
